
  import { Vue, Component, Prop } from "vue-property-decorator";
  import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
  import RouteNames from "@/entities/RouteNames";

  @Component({
    components: {
      CircleWithInitials,
    }
  })
  export default class ProjectGroup extends Vue {
    @Prop({ type: String, default: undefined }) readonly name!: string;
    @Prop({ type: String, required: true }) readonly id!: string;

    routes = RouteNames;

    get projectRoute(): string {
      return RouteNames.PROJECT_ACTIVITY;
    }
  }
